import { onUnmounted, ref, watch } from "vue";

const decimalFormatter = new Intl.NumberFormat("ru-RU", { style: "decimal", minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });

export const formatPrice = (value: number | string, symbol?: string | null) => {
	const numeric = Number(value);
	const formatted = decimalFormatter.format(Number.isFinite(numeric) ? numeric : 0);
	if (symbol) return `${formatted} ${symbol}`;
	return formatted;
};

export const useAnimatedNumber = (initialValue: number, duration = 800) => {
	const displayNumber = ref(initialValue);
	const targetNumber = ref(initialValue);
	let animationFrameId: number | null = null;
	let startTime: number | null = null;
	let startValue = initialValue;

	const animate = (timestamp: number) => {
		if (!startTime) startTime = timestamp;
		const elapsed = timestamp - startTime;
		const progress = Math.min(elapsed / duration, 1);
		const easing = progress < 0.5 ? 4 * progress * progress * progress : 1 - (-2 * progress + 2) ** 3 / 2;

		displayNumber.value = Math.round(startValue + (targetNumber.value - startValue) * easing);

		if (progress < 1) {
			animationFrameId = requestAnimationFrame(animate);
		} else {
			displayNumber.value = targetNumber.value;
			animationFrameId = null;
		}
	};

	watch(
		targetNumber,
		() => {
			if (animationFrameId) cancelAnimationFrame(animationFrameId);
			startValue = displayNumber.value;
			startTime = null;
			animationFrameId = requestAnimationFrame(animate);
		},
		{ immediate: true },
	);

	onUnmounted(() => {
		if (animationFrameId) cancelAnimationFrame(animationFrameId);
	});

	return {
		displayNumber,
		update: (value: number | string) => {
			targetNumber.value = Number(value);
		},
	};
};
